export default __webpack_public_path__ + "images/AU.e743def.png";